<template>
  <div>
    <v-autocomplete
      item-text="name"
      item-value="id"
      :hint="
        $capitalize($tc('model.unities_choice_message'))
      "
      persistent-hint
      :value="actuation_zones"
      :items="country_areas"
      :loading="loading"
      :disabled="loading"
      @input="handleSelect"
      multiple
      v-bind="$props"
      return-object
    >
      <template v-slot:selection="{ item }">
        <v-chip 
          close
          :disabled="getCountryAreaStatus(item)"
          @click:close="removeCountryArea(item)" 
        >
          <v-menu offset-overflow>
            <template v-slot:activator="{on, attrs}" >
              <v-btn :title=" $capitalize($tc('model.unities_counties_message'))" v-bind="attrs" v-on="on" icon small @click="setOpenedCountryArea(item)">
                <v-icon>mdi-playlist-edit</v-icon>
              </v-btn>
            </template>
          </v-menu>
          <span>{{ `${getCountryAreaCityCount(item)} ${item.name}` }}</span>
        </v-chip>
      </template>
    </v-autocomplete>  
    <v-dialog v-model="opened_dialog" persistent width="300">
      <v-card flat class="menu" max-width="400" v-if="opened_country_area">
        <v-card-title>{{ $capitalize($tc("model.unities_counties_message")) }}</v-card-title>
          <v-card-text>
            <select-cities-country-area
              name="cities"
              :country_area="opened_country_area"
              @change="handleSelectCity"
            ></select-cities-country-area>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" text>{{ $capitalize($tc("model.unities_close")) }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getCountryAreas, getCities } from '../../services/locals';
import SelectCitiesCountryArea from '../locals/SelectCitiesCountryArea';

export default {
  name: "select-actuation-zone",
  components: { SelectCitiesCountryArea },
  props: {
    actuation_zones: Array,
    label: String,
    name: String,
    "error-messages": Array
  },
  model: {
    prop: 'actuation_zones',
    event: 'change'
  },
  data: () => ({
    loading: false,
    opened_country_area: null,
    opened_dialog: false,
    country_areas: []
  }),
  methods: {
    handleSelect(value) {
      this.$emit('change', value);
    },
    handleSelectCity(value) {
      this.$emit('change', this.actuation_zones.map(actuation_zone => {
        if (actuation_zone.id === this.opened_country_area.id) {
          return {...actuation_zone, cities: value}
        }

        return actuation_zone;
      }));
    },
    selectCountryArea(item) {
      return this.actuation_zones.find(country_area => country_area.id == item.id);
    },
    setOpenedCountryArea(item) {
      this.opened_dialog = true;
      this.opened_country_area = this.selectCountryArea(item);
    },
    getCountryAreaCityCount(item) {
      const country_area = this.selectCountryArea(item);

      if (country_area.cities)
        return `(${country_area.cities ? country_area.cities.length : 0})`;
      else
        return '';
    },
    getCountryAreaStatus(item) {
      return this.selectCountryArea(item)?.loading;
    },
    removeCountryArea(item) {
      this.$emit('change', this.actuation_zones.filter(zone => zone.id != item.id));
    },
    closeDialog() {
      this.opened_dialog = false;
      this.opened_country_area = null;
    },
    async fetchCountryAreas() {
      this.loading = true;
      this.country_areas = await getCountryAreas('pt');
      this.loading = false;
    },
    async fetchCountryAreasCities(zones) {
      try {
        for (const zone of zones) {
          this.loading = true;
          zone.loading = true;

          if (!zone.cities) {
            const list_cities = await getCities(zone.id);
            zone.list_cities = list_cities;
            zone.cities = list_cities.map(city => city.id);
          }

          zone.loading = false;
        }
      } catch (error) {
        this.$store.commmit("sendMessage", {
          text: "Falha ao carregar concelhos",
          color: "red"
        });
      } finally {
        if (!this.actuation_zones)
          this.loading = false;
        else if (!this.actuation_zones.some(zone => !zone.cities))
          this.loading = false;
        
        this.$emit('change', this.actuation_zones);
      }
    }
  },
  created() {
    this.fetchCountryAreas();
  },
  watch: {
    actuation_zones: function(value, oldValue) {
      const lastAdded = (value ? value.filter(x => {
        if (oldValue && oldValue.includes(x))
          return false;
        
        return true;
      }) : []);

      this.fetchCountryAreasCities(lastAdded);
    }
  }
};
</script>